
import {
  reactive,
  onMounted,
  onUnmounted,
  defineComponent,
  computed,
  Ref,
  ref,
} from "vue";
import BoardPane from "./BoardPane.vue";
import RecordPane, { minWidth as minRecordWidth } from "./RecordPane.vue";
import TabPane, {
  headerHeight as informationHeaderHeight,
  minHeight as minTabHeight,
} from "./TabPane.vue";
import { RectSize } from "@/components/primitive/Types";
import { useStore } from "@/store";
import { Tab } from "@/settings/app";

export default defineComponent({
  name: "StandardLayout",
  components: {
    BoardPane,
    RecordPane,
    TabPane,
  },
  setup() {
    const store = useStore();
    const windowSize = reactive(new RectSize(0, 0));
    const topPaneHeight = ref(0);
    const topPane: Ref = ref(null);

    const updateSize = () => {
      windowSize.width = window.innerWidth;
      windowSize.height = window.innerHeight;
    };

    const topPaneResizeObserver = new ResizeObserver((entries) => {
      topPaneHeight.value = entries[0].contentRect.height;
    });

    onMounted(() => {
      updateSize();
      window.addEventListener("resize", updateSize);
      topPaneResizeObserver.observe(topPane.value);
    });

    onUnmounted(() => {
      window.removeEventListener("resize", updateSize);
      topPaneResizeObserver.disconnect();
    });

    const boardPaneMaxSize = computed(() => {
      const minTabPaneHeight =
        store.state.appSetting.tab !== Tab.INVISIBLE
          ? minTabHeight
          : informationHeaderHeight;
      return new RectSize(
        windowSize.width - minRecordWidth,
        windowSize.height - minTabPaneHeight
      );
    });

    const bottomPaneSize = computed(() => {
      return new RectSize(
        windowSize.width,
        windowSize.height - topPaneHeight.value
      );
    });

    return {
      topPane,
      boardPaneMaxSize,
      bottomPaneSize,
    };
  },
});
